import React from 'react';
import styled from 'styled-components';
import { I18n } from 'react-redux-i18n';

import Card from 'components/Card';
import CardHeader from 'components/CardHeader';
import SubmissionsTables from 'modules/Negoce/components/SubmissionsHistory/Table';

import { components } from 'apiTyped/types';

const Title = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    flex-direction: column;
  }

  h1.title {
    font-size: 20px;
    font-family: ${(props) => props.theme.fonts.oswald};
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    color: #202529;
    text-transform: uppercase;
  }

  .titleContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    white-space: normal;
  }
`;

const SubmissionsHistory = ({
  submissions = []
}: {
  submissions?: components['schemas']['Submission'][];
}) => (
  <Card>
    <CardHeader
      styles={`.cardHeader{width:90%}`}
      title={
        <Title>
          <div className="titleContainer">
            <h1 className="title">
              {I18n.t('negoce.submissions.loadingHistory.title')}
            </h1>
          </div>
        </Title>
      }
      fontSize="20px"
    />
    <SubmissionsTables submissions={submissions} />
  </Card>
);

export default SubmissionsHistory;
